/* eslint-disable jsx-a11y/anchor-is-valid */
// เพิ่ม eslint-disable เพราะว่ารำคาญบรรทัดสีฟ้าที่ชอบขึ้นใน VSCode
import React, { useEffect } from 'react';

const Pagination = ({
  currentPage,
  setCurrentPage,
  itemsPerPage,
  dataMasterList,
  handlePageChange,
}) => {
  const totalPages = Math.ceil(dataMasterList.length / itemsPerPage);
  const maxVisiblePages = 5;
  const range = Math.floor(maxVisiblePages / 2);
  const pages = [];

  // ดึง currentPage จาก localStorage ตอน component โหลด
  useEffect(() => {
    const storedPage = localStorage.getItem('currentPage');
    if (storedPage) {
      const page = Number(storedPage);
      // ตรวจสอบว่าหน้าที่เก็บไว้ถูกต้องหรือไม่ (อยู่ในช่วงที่เป็นไปได้)
      const totalPages = Math.ceil(dataMasterList.length / itemsPerPage);
      if (page >= 1 && page <= totalPages && page !== currentPage) {
        if (typeof setCurrentPage === 'function') {
          setCurrentPage(page);
        }
        if (typeof handlePageChange === 'function') {
          handlePageChange(page);
        }
      }
    }
  }, [currentPage, dataMasterList.length, itemsPerPage, setCurrentPage, handlePageChange]);

  // ฟังก์ชันเปลี่ยนหน้า และเก็บลง localStorage + เซ็ต currentPage
  const handlePageChangeWithStorage = (pageNumber) => {
    localStorage.setItem('currentPage', pageNumber);
    if (typeof setCurrentPage === 'function') {
      setCurrentPage(pageNumber);
    }
    if (typeof handlePageChange === 'function') {
      handlePageChange(pageNumber);
    }
  };

  // คำนวณ startPage / endPage
  let startPage = Math.max(currentPage - range, 1);
  let endPage = Math.min(currentPage + range, totalPages);

  // ถ้าจำนวนหน้ามีน้อยกว่าจำนวนที่ต้องการแสดง
  if (totalPages <= maxVisiblePages) {
    startPage = 1;
    endPage = totalPages;
  }

  // ถ้าจำนวนหน้าต้องการแสดงเป็น 5 หน้า
  if (endPage - startPage < maxVisiblePages - 1) {
    if (startPage === 1) {
      endPage = Math.min(startPage + maxVisiblePages - 1, totalPages);
    } else {
      startPage = Math.max(endPage - maxVisiblePages + 1, 1);
    }
  }

  for (let i = startPage; i <= endPage; i++) {
    pages.push(
      <li
        key={i}
        className={`paginate_button page-item ${currentPage === i ? "active" : ""}`}
      >
        <a
          href="#"
          className="page-link"
          onClick={(e) => {
            e.preventDefault();
            handlePageChangeWithStorage(i);
          }}
        >
          {i}
        </a>
      </li>
    );
  }

  return (
    <div className="row mt-3">
      <div className="col-12 d-flex justify-content-end">
        <div className="dataTables_paginate paging_simple_numbers">
          <ul className="pagination">
            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
              <a
                href="#"
                className="page-link"
                onClick={(e) => {
                  e.preventDefault();
                  if (currentPage > 1) handlePageChangeWithStorage(currentPage - 1);
                }}
                aria-label="Previous"
              >
                <span aria-hidden="true">&laquo;</span>
              </a>
            </li>

            {pages}

            <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
              <a
                href="#"
                className="page-link"
                onClick={(e) => {
                  e.preventDefault();
                  if (currentPage < totalPages) handlePageChangeWithStorage(currentPage + 1);
                }}
                aria-label="Next"
              >
                <span aria-hidden="true">&raquo;</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Pagination;